import { createStyles, Fab, makeStyles, SvgIconProps, Theme } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';
import PanToolIcon from '@material-ui/icons/PanTool';

export interface HeaderActionButtonProps {
    items: Array<{
        icon: 'delete' | 'edit' | 'lock' | 'lock_open' | 'add' | 'assign'
        onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
        color?: SvgIconProps['color'];
        size?: string
        textUrl?: string
        handleDelete?: () => Promise<void>
        alertMessage?: string
        selectList?: Array<{ name: string, value: string }>
        onSelectClick?: (event: React.ChangeEvent<{ value: unknown }>) => Promise<void>
        selectedValue?: string;
        disabled?: boolean;
    }>


}

const getIconComponent = (icon: 'delete' | 'edit' | 'lock' | 'lock_open' | 'add' | 'assign') => {
    switch (icon) {
        case 'delete': return DeleteIcon;
        case 'edit': return EditIcon;
        case 'lock': return LockIcon;
        case 'lock_open': return LockOpenIcon;
        case 'add': return AddIcon;
        case 'assign': return PanToolIcon;
    }
}

const HeaderActionButtons: React.FC<HeaderActionButtonProps> = (props) => {

    const classes = useStyles(props)
    const { items } = props;
    return (
        <div className={classes.operationButtons}>
            {
                items.map((item, index) => {
                    const IconComponent = getIconComponent(item.icon);
                    return (
                        <Fab size={'small'} key={index} onClick={item.onClick} disabled={item.disabled} color={item.icon === 'add' ? 'primary' : (item.icon === 'lock' ? 'secondary' : 'inherit')} >
                            <IconComponent color={item.color || 'inherit'} />
                        </Fab>
                    )
                })
            }
        </div>
    )
}

const useStyles = makeStyles<Theme, HeaderActionButtonProps>((theme) => createStyles({
    operationButtons: {
        display: 'flex',
        justifyContent: 'center',
        color: 'white',
        margin: '20px 0px',
        // color: '#fff',
        '& > button': {
            margin: '0 10px',
            // backgroundColor: '#fff'
        },
        '& > div': {
            margin: '0 10px'
        }
    },
}))

export default HeaderActionButtons